import React from 'react'
import { useSelector } from 'react-redux';
import { getPercentileInfo } from '../../util/cutscores';

export default function ThreadOverviewCell(props) {
  const {PR} = props;

  const selectedStatePercentileCuts = useSelector(state => state.reports.teacher.selectedStatePercentileCuts);

  const cellStyle = {};
  const percentileInfo = getPercentileInfo(PR, selectedStatePercentileCuts);
  cellStyle.backgroundColor = percentileInfo.color;
  if (!PR && PR !== 0) cellStyle.backgroundColor = '#f9f6f2';
  else cellStyle.color = "white";

  return <div className="classProgressCellData" style={cellStyle}>{PR ?? " "}</div>;
}
